import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'

export default {
	/**
	 * 列表接口
	 * @param {page} 第几页
	 * @return {pageSize} 每页数量
	**/
	loRaProjectList( params={} ) {
		return request({
	    url: baseUrl + '/auth/getLoRaProject',
	    method: 'GET',
	    params
	  })
	},
	/**
	 * 添加接口
	**/
    loRaProjectAdd(data) {
		return request({
	    url: baseUrl + '/auth/addLoRaProject',
	    method: 'POST',
	    data
	  })
	}
}